
























import { Component, Vue } from "vue-property-decorator";
import FeatureCard from "@/components/FeatureCard.vue";

@Component({
  components: {
    FeatureCard
  }
})
export default class WhatSection extends Vue {
  data() {
    return {
      imagePath: function (name:string): any {
        return require("../assets/images/" + name)
      }, 
      cardData: [
        {
          layoutClasses: "",
          title: "What we can do",
          content: "1. High-resolution immersive experience<br><br>2. Intuitive user-friendly interface<br><br>3. Gadgets and app free<br><br>4. Customized design<br><br>5. Low cost",
          btnText: "Check out a Demo",
          img: "feature-shop.jpg",
        }
      ]
    };
  }
}
